
<script setup lang="ts">
const props = withDefaults(defineProps<{
  id: string,
  media: {
    source: 'vimeo' | 'youtube' | 'local',
    vid?: string, // Vimeo/Youtube video ID
    src?: string, // Local video path
    image?: string,
    alt?: string
  },
  imgStyles?: Record<string, string | number>,
  imgClass?: string
}>(), {
  id: '',
  media: () => ({
    source: 'vimeo',
    vid: '1014746311',
    src: '',
    image: '/images/1.jpeg',
    alt: '',
  }),
  imgStyles: () => ({}),
  imgClass: ""
});

const bgImageStyle = computed(() => ({
  backgroundImage: `url(${props.media.image})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
}));
</script>

<template>
  <div class="io-hero-media-video hero-slide relative" :class="id">
    <div class="header-media-image">
      <div :style="bgImageStyle" class="media-image" />
    </div>

    <div v-if="media.source === 'vimeo'" class="video-wrapper vimeo">
      <iframe
        :src="`https://player.vimeo.com/video/${media.vid}?background=1&autoplay=1&loop=1&byline=0&title=0&muted=1&controls=0&dnt=0`"
        frameborder="0"
      />
    </div>

    <div v-if="media.source === 'youtube'" class="video-wrapper youtube">
      <iframe
        :src="`https://www.youtube.com/embed/${media.vid}?autoplay=1&loop=1&playlist=${media.vid}&controls=0&showinfo=0&modestbranding=1&rel=0&mute=1&enablejsapi=1`"
        frameborder="0"
      />
    </div>

    <div v-if="media.source === 'local'" class="video-wrapper local">
      <video autoplay loop muted playsinline>
        <source :src="media.src" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.io-hero-media-video {
  width: 100%;
  height: 100%;
  position: relative;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  grid-template-areas: "layer";

  > .header-media-image {
    height: 100%;
    width: 100%;
    grid-area: layer;

    .media-image {
      height: 100%;
      width: 100%;
      background-size: cover;
      background-position: center;
      background-attachment: fixed;
    }
  }

  > .video-wrapper {
    width: 100%;
    height: 100%;
    position: relative;
    z-index: 10;
    overflow: hidden;
    grid-area: layer;

    iframe, video {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 100vw;
      height: 120%;
      object-fit: cover;

      @include mq($until: mlx) {
        width: 500vw;
      }
      @include mq($from: mlx, $until: t) {
        width: 300vw;
      }
      @include mq($from: t, $until: d) {
        width: 200vw;
      }

      @include mq($from: d) {
        height: 100vh;
      }
      @include mq($from: d, $until: dm) {
        width: 150vw;
      }
      
    }
  }
}
</style>
